import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from './redux-hooks';
import { setLocale } from '../../store/redux/menuSlice';
import { supportedLocalesOf } from '../localization/apply';
import { localeStorageKey } from '../localization/languages';

export function useMenuLanguage() {
    const dispatch = useAppDispatch();
    const { menu, locale, showLanguageSwitcher } = useAppSelector((state) => state.menu);

    const changeLocale = useCallback(
        (next: string) => {
            dispatch(setLocale(next));
            if (!menu) return;
            try {
                localStorage.setItem(localeStorageKey(menu.id), next);
            } catch {
                // private mode
            }
        },
        [dispatch, menu]
    );

    return {
        locale,
        locales: supportedLocalesOf(menu),
        showLanguageSwitcher: showLanguageSwitcher && !!menu,
        changeLocale,
    };
}
